import replaceAttachmentInWell from '../actions/replaceAttachmentInWell';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import {
    AttachmentFullViewState,
    createAttachmentFullViewStateAndStoreBackingModel,
} from 'owa-attachment-full-data';

export default function replaceAttachment(
    attachmentWellViewState: AttachmentWellViewState,
    attachmentViewState: AttachmentFullViewState,
    attachmentType: AttachmentType,
    isReadOnly: boolean,
    uploadCompleted: boolean
): void {
    // Getting the mailboxInfo from attachmentViewState of the attachment to be replaced
    // as that info should not change for the new attachment which is replacing the current attachment.
    const newAttachmentViewState = createAttachmentFullViewStateAndStoreBackingModel(
        {
            ...attachmentType.AttachmentId,
            mailboxInfo: attachmentViewState.attachmentId.mailboxInfo,
        },
        attachmentType,
        isReadOnly,
        uploadCompleted,
        true
    );
    replaceAttachmentInWell(
        attachmentWellViewState,
        attachmentViewState,
        newAttachmentViewState,
        attachmentType.Size
    );
}
